import { apiDatesAdapters, startOfDay } from '@sequencehq/utils/dates'

/**
 * An entity (invoice/credit note) is locked out of finalising/sending when it
 * is dated strictly before the account's accounting lock date.
 *
 *   entityDate ----|---- lockDate ---->
 *           BEFORE  |  ON/AFTER
 *           locked  |  allowed
 *
 * No lock date (or a missing entity date) means nothing is locked.
 */
export const isDatedBeforeLockDate = ({
  entityDate,
  lockDate
}: {
  entityDate?: string | null
  lockDate?: string | null
}): boolean => {
  if (!entityDate || !lockDate) {
    return false
  }

  const entity = apiDatesAdapters.fromApi(entityDate)
  const lock = apiDatesAdapters.fromApi(lockDate)

  if (!entity || !lock) {
    return false
  }

  return startOfDay(entity) < startOfDay(lock)
}
